import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
export function VendorRegister() {
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-677">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-678">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-679">
          Vendor Registration
        </h2>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-680">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-681">
          <div className="text-center" data-id="element-682">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100 mb-4" data-id="element-683">
              <AlertCircle className="h-6 w-6 text-yellow-600" data-id="element-684" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-685">
              Direct Registration Not Available
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-686">
              We require an assessment process before accepting new vendors.
              Please visit our "Become a Vendor" page to express your interest.
            </p>
            <Link to="/become-vendor" className="inline-flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-white bg-primary hover:bg-primary/90" data-id="element-687">
              Go to Become a Vendor
            </Link>
          </div>
        </div>
      </div>
    </div>;
}